import { getCookie, setCookie } from '@utiljs/cookie';
import { getEnv, ENV } from '@utils/getEnv';
import * as Ids from '@utils/ids';
import { reportCustomError } from '@utils/owlReporter';

import PushClient, { PushClientEventHandler } from './PushClient';

const establishPushConnection = (handlers?: Partial<PushClientEventHandler>) => {
    const multiDomainGrayPercent = window.pushPercentage || 0;
    const acctIdStr = Ids.getAcctId();
    const acctId = Number(acctIdStr);

    // 🚩 确定要使用的 push 域名
    const pushDomainList: string[] = [];
    pushDomainList.push(getCookie('wpush_server_url') || 'wss://wpush.meituan.com');

    if (getEnv() === ENV.TEST && window.location.protocol === 'https:') {
        // 测试环境通过https访问需要强制将wpush链接替换为wss协议
        pushDomainList[0] = (pushDomainList[0] || '').replace(/^ws:/, 'wss:');
    }

    // 线上环境命中多域名容灾灰度，增加两个备用域名
    if (
        getEnv() === ENV.PRODUCTION &&
        !Number.isNaN(acctId) &&
        acctId % 100 < multiDomainGrayPercent
    ) {
        pushDomainList.push(
            'wss://bj-wpush.waimai.meituan.com',
            'wss://sh-wpush.waimai.meituan.com',
        );
    }

    //  🚩 读取 pushToken
    let pushToken = getCookie('pushToken');
    if (!pushToken) {
        // pushToken 失效，取 token 作为 pushToken
        const now = new Date();
        setCookie('pushToken', Ids.getToken(), {
            expires: new Date(now.getTime() + 365 * 24 * 60 * 60 * 1000),
        });
        pushToken = Ids.getToken();
    }

    if (pushToken.indexOf('%2A') !== -1) {
        reportCustomError({
            name: 'pushToken 异常 - 建连',
            message: `acctId: ${acctIdStr}, poiId: ${Ids.getWmPoiId()}, pushToken: ${pushToken}, token: ${Ids.getToken()}`,
            level: 'WARN',
        });
    }

    // 🚩 初始化 PushClient 实例
    const pushUrlList = pushDomainList.map(domain => `${domain}/websocket/waimai_e/${pushToken}`);

    const pushClient = new PushClient(pushUrlList, handlers);

    return pushClient;
};

export default establishPushConnection;
